export class AvverkningsanmalanTyp {
// eslint-disable-next-line sonarjs/public-static-readonly
    static sveaskog = "Manuell registrering";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static leverantor = "Leverantören ansvarar för anmälan";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static anmalanWeb = "Registrerad via Anmälan Web";
}
